import { Component, Inject, OnInit } from '@angular/core';
import { MenuItemsService } from '../shared/services/menu-items/menu-items.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfigService } from '../reactive-forms/services/app-config.service';
import { UserInfo } from '../userInfo';
import { RecentScreensService } from '../shared/services/RecentScreensService/recent-screens.service';
import { TranslateService } from '@ngx-translate/core';
import { FavoriteScreensService } from '../shared/services/favorite-screens.service';
@Component({
	selector: 'app-home',
	templateUrl: 'home.component.html',
	styleUrls: ["home.component.scss"]
})


export class HomeComponent implements OnInit {
	cover: string;
	public _userinfo = UserInfo;
	public greeting: string;
	public recentScreens: { Path: string; ItemName: string;}[];
	public favoriteScreens: { Path: string; ItemName: string; Parent: string}[];
	constructor(
		public menuItemsService: MenuItemsService,
		private router: Router,
		private route: ActivatedRoute,
		private environment: AppConfigService,
		private recentScreensService: RecentScreensService,
		private translateService: TranslateService,
		@Inject('UIUserProfile') private uiProfileService,
		private favoriteScreensService: FavoriteScreensService
	) { }

	ngOnInit() {
		this.route.data.subscribe(res => {
			this.cover = res.coverResolver?.value?.[0]?.['ImagePath'] 
				? `url(${this.environment.boURL}/CompanyImagesUploads/${encodeURIComponent(res.coverResolver.value[0]['ImagePath'])
					.replace(/\(/g, '%28')
      				.replace(/\)/g, '%29')})`
				: 'url(assets/images/landing-banner2.png)';
		})
		
		
		this.getRecentsFromLocalStorage();
		this.getFavoritesFromLocalStorage();
		this.setGreeting();
	}

	
	private getRecentsFromLocalStorage(){
		this.recentScreens = this.recentScreensService.getRecentPagesFlattenedList().map( page => ({
			ItemName: page.PageName,
			Path: page.PageUrl,
			Parent: page.PageUrl.split('/')[0]
		}))
	}

	private getFavoritesFromLocalStorage(){
		this.favoriteScreens = this.favoriteScreensService.getLocalFavoritePagesFlattenedList()
		.map(s => ({
			ItemName: s.PageName,
			Path: s.PageUrl,
			Parent: s.PageUrl.split('/')[0]
		}));
	}
	private setGreeting(): void {
		const currentHour = new Date().getHours();
		
		if (currentHour < 12) {
		  this.greeting = this.translateService.instant('Good Morning');
		} else if (currentHour < 18) {
		  this.greeting =  this.translateService.instant('Good Afternoon');
		} else {
		  this.greeting =  this.translateService.instant('Good Evening');
		}
	  }

	navigateToPage(text: string) {
		this.router.navigate([`AreaPage`], { queryParams: { module: text } });
	}

	isSupervisor() {
    return this._userinfo.UserCode?true:false;
	}
}